'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { FilterContent } from './FilterModal';
import { SearchInput, SearchBarContainer } from './SearchBar';

/**
 * Desktop filter panel component - displays inline with list view
 * Uses shared FilterContent component for consistency with FilterModal
 */
export function FilterPanel(t0) {
  const $ = _c(11);
  const {
    className: t1,
    filterClass: t2,
    dynamicHeight: t3
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const filterClass = t2 === undefined ? "" : t2;
  const dynamicHeight = t3 === undefined ? false : t3;
  const panelRef = useRef(null);
  const contentRef = useRef(null);
  let t4;
  let t5;
  if ($[0] !== dynamicHeight) {
    t4 = () => {
      if (!dynamicHeight) {
        return;
      }
      const updateHeight = () => {
        if (!panelRef.current) {
          return;
        }
        const topOffset = panelRef.current.getBoundingClientRect().top;
        const viewportHeight = window.innerHeight;
        const maxHeight = viewportHeight - topOffset - 80;
        panelRef.current.style.setProperty("--filter-max-height", `${Math.max(maxHeight, 0)}px`);
      };
      updateHeight();
      window.addEventListener("scroll", updateHeight, {
        passive: true
      });
      window.addEventListener("resize", updateHeight);
      let resizeObserver;
      if (contentRef.current) {
        resizeObserver = new ResizeObserver(() => {
          updateHeight();
        });
        resizeObserver.observe(contentRef.current);
      }
      return () => {
        window.removeEventListener("scroll", updateHeight);
        window.removeEventListener("resize", updateHeight);
        resizeObserver?.disconnect();
      };
    };
    t5 = [dynamicHeight];
    $[0] = dynamicHeight;
    $[1] = t4;
    $[2] = t5;
  } else {
    t4 = $[1];
    t5 = $[2];
  }
  useEffect(t4, t5);
  const t6 = `flex flex-col ${className}`;
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div><SearchBarContainer><SearchInput id="searchLocation" searchClass="right-2 pr-2 text-[#D9D9D9]" serchInputClass="!text-base pr-10 !placeholder:text-[#757575] border-r border-[#00ffff] !bg-transparent border border-[#DDD] !shadow-none text-lg text-[#757575] leading-[1em]" /></SearchBarContainer></div>;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const t8 = `overflow-y-auto mt-3 ${filterClass} `;
  let t10;
  let t9;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      maxHeight: "var(--filter-max-height)"
    };
    t10 = <FilterContent showHeader={false} variant="panel" toggleWrapperClass="space-y-0.5" />;
    $[4] = t10;
    $[5] = t9;
  } else {
    t10 = $[4];
    t9 = $[5];
  }
  let t11;
  if ($[6] !== t8) {
    t11 = <div ref={contentRef} className={t8} style={t9}>{t10}</div>;
    $[6] = t8;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== t11 || $[9] !== t6) {
    t12 = <div ref={panelRef} className={t6}>{t7}{t11}</div>;
    $[8] = t11;
    $[9] = t6;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  return t12;
}